import React, { useState, useEffect } from "react";
import axios from "axios";

const FacebookAutoControl = () => {
  const [status, setStatus] = useState("WAIT");
  const [loading, setLoading] = useState(false);

  const fetchStatus = async () => {
    try {
      const res = await axios.get("/api/automation-status");
      setStatus(res.data.status);
    } catch (err) {
      console.error("Error fetching status:", err);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

const handleStartAutomation = async () => {
  try {
    setLoading(true);
    await axios.post("/api/automation-status", { status: "RUN" });
    setStatus("RUN");

    // תן לו זמן לבד להתאפס בשרת – רק תעדכן תצוגה
    setTimeout(() => {
      setStatus("WAIT");
      setLoading(false);
    }, 9000);
  } catch (err) {
    console.error("Error updating status:", err);
    setLoading(false);
  }
};

  return (
    <div className="p-6 max-w-md mx-auto bg-white rounded-xl shadow-md text-center">
      <h1 className="text-2xl font-bold mb-4">Facebook Automation Status</h1>
      <p className="mb-4 text-lg">Current Status: <span className={status === "RUN" ? "text-green-600" : "text-red-600"}>{status}</span></p>
      <button
        onClick={handleStartAutomation}
        disabled={status === "RUN" || loading}
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
      >
        Start Automation
      </button>
    </div>
  );
};

export default FacebookAutoControl;
